"use client"

import { useTranslations } from "next-intl"

import { Button } from "@/components/ui/button"

import { useConsent } from "./context"

/**
 * Lives at the bottom of the Cookie Policy so withdrawing consent is as easy
 * as giving it (the banner comes straight back).
 */
export default function ManageConsentButton() {
  const t = useTranslations("Consent")
  const { ready, choice, reset } = useConsent()

  if (!ready) {
    return null
  }

  const current =
    choice === "all"
      ? t("acceptAll")
      : choice === "essential"
        ? t("essentialOnly")
        : t("notDecided")

  return (
    <div
      className="mt-8 flex flex-wrap items-center gap-x-3 gap-y-2 rounded-large border border-ui-border-base p-4"
      data-testid="manage-consent"
    >
      <p className="txt-compact-small text-ui-fg-subtle">
        {t("currentChoice", { choice: current })}
      </p>
      <Button size="sm" variant="secondary" onClick={reset} data-testid="consent-reset">
        {t("changeChoice")}
      </Button>
    </div>
  )
}
